import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as customControlActions from 'actions/customControlActions';
import CustomControl from 'components/CustomControl/CustomControl';
import { debounce } from 'utils/utils';

/* istanbul ignore next */
const mapStateToProps = state => ({
  customControlState: state.customControl || {},
});

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    customControlActionsBound: bindActionCreators(customControlActions, dispatch),
  };
}

export class CustomControlLayout extends Component {
  static propTypes = {
    customControlState: PropTypes.object,
    customControlActionsBound: PropTypes.object,
  }

  componentDidMount() {
    this.debouncedResizeHandler = debounce(this.handleWindowResize, 150);
    window.addEventListener('resize', this.debouncedResizeHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.debouncedResizeHandler);
  }

  handleWindowResize = () => {
    const { customControlActionsBound } = this.props;
    customControlActionsBound.hideControl();
  }

  closeCustomControl = (event) => {
    const { customControlActionsBound } = this.props;
    event.preventDefault();
    customControlActionsBound.hideControl();
  }

  render() {
    const { customControlState } = this.props;

    const body = customControlState.body;

    return (
      <div>
        { body && (
          <CustomControl
            closeCustomControl={this.closeCustomControl}
            customControlState={customControlState}
            body={body}
            position={customControlState.position}
            hAlign={customControlState.hAlign}
            width={customControlState.width}
            height={customControlState.height}
          />
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomControlLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/CustomControlLayout/CustomControlLayout.jsx
 **/